/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import "./Body.scss";
import { ApplicationStatus } from "../constants";
import React from "react";
import { ReferenceHistoryWrapper } from "../reference-history";
import { UploadOrDecline } from "../upload-decline";
import { NoteEditSVG } from "../assets/note-edit";
interface Props {
  advisorName: string;
  candidateFirstName: string;
  candidateLastName: string;
  updatedDate: string;
  status: ApplicationStatus;
  setAppStatus: (status: ApplicationStatus) => void;
}
export const Body: React.FC<Props> = ({
  advisorName,
  candidateFirstName,
  candidateLastName,
  updatedDate,
  status,
  setAppStatus,
}) => {
  return (
    <div className="ms-ac-referenceview-app-body">
      <p className="ms-ac-referenceview-welcome-text">
        Hello {advisorName}! Welcome to Microsoft Recruiting References portal.
      </p>
      <div className="ms-ac-referenceview-action-container">
        <UploadOrDecline
          candidateFirstName={candidateFirstName}
          candidateLastName={candidateLastName}
          updatedDate={updatedDate}
          status={status}
          setAppStatus={setAppStatus}
        />
        <ReferenceHistoryWrapper
          candidateFirstName={candidateFirstName}
          candidateLastName={candidateLastName}
          status={status}
        />
      </div>
      <NoteEditSVG></NoteEditSVG>
    </div>
  );
};
